import { IMainView } from "@ancademy/vse-client";
import { Create } from "./Create";
import { Lobby } from "./Lobby";
import { Login } from "./Login";
import { Play } from "./Play";
import { Play4Owner } from "./Play4Owner";
import { ReportViewer } from "./ReportViewer";

export const mainView: IMainView = {
  Login,
  Lobby,
  Create,
  Play,
  Play4Owner,
  ReportViewer,
};
